import React from 'react';
import useMediaQuery from "@mui/system/useMediaQuery";
import {Typography, useTheme} from "@mui/joy";
import Dialog from "@mui/material/Dialog";
import {BasicModalContent} from "@dreebit-registry/vsm-microservice-components";
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {toast} from "react-toastify";
import _ from "lodash";
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";
import {GridViewTDAs} from "../../graphql/queries/gridViewTDAs";
import {UpdateGridView} from "../../graphql/mutations/updateGridView";

interface Props {
    open: boolean,
    gridViewId: string,
    onClose?: () => void,
}

const UpdateGridViewModal = ({onClose, gridViewId, open}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {t} = useTranslation();

    const [updateGridViewMutation] = useMutation(UpdateGridView);

    const {data} = useQuery(GridViewTDAs, {
        variables: {
            id: gridViewId
        },
        fetchPolicy: "network-only",
    })

    const handleSubmit = (input: any) => {
        return updateGridViewMutation({
                variables: {
                    id: gridViewId,
                    input: input
                },
                refetchQueries: ["GridViewList"]
            }
        ).then((res) => {
            if (onClose) {
                onClose();
            }
        }).catch((err) => {
            toast.error(resolveErrorMessage(err, t))
        })
    }

    const title = _.get(data, 'gridView.title', t('Grid View'));

    let attributes = _.get(data, 'gridView.typeDefinitionAttributeList.typeDefinitionAttributes', [])
    attributes = attributes.map((a: any) => {
        if (a.index === "rotationTime") {
            return {
                ...a,
                hint: t("Time in seconds how long each grid is displayed in loop mode"),
            }
        } else {
            return a
        }
    })

    return <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
        <BasicModalContent
            onClose={onClose}
            title={<Typography level={'titleSmallLight'}>{t('Edit')}: <Typography level={'titleSmall'}>{title}</Typography></Typography>}
        >
            <InstalledBaseTDAForm
                formStyle={{paddingTop: '0px'}}
                onSubmit={handleSubmit}
                onCancel={onClose}
                submitButtonText={t('Update')}
                attributes={attributes}
            />
        </BasicModalContent>
    </Dialog>
};

export default UpdateGridViewModal;
